"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishRequestSchema = exports.DocumentUpdateSchema = exports.DocumentCreateSchema = exports.DocumentListResponseSchema = exports.DocumentListQuerySchema = exports.DocumentDetailSchema = exports.DocumentReceiverSchema = exports.FileMetaSchema = exports.DocumentSummarySchema = void 0;
const zod_1 = require("zod");
exports.DocumentSummarySchema = zod_1.z.object({
    documentId: zod_1.z.number(),
    registerNumber: zod_1.z.string().nullable(),
    code: zod_1.z.string().nullable(),
    title: zod_1.z.string().nullable(),
    signer: zod_1.z.string().nullable(),
    promulgateDate: zod_1.z.string().nullable(),
    receiveDate: zod_1.z.string().nullable(),
    deadlineDate: zod_1.z.string().nullable(),
    priorityId: zod_1.z.number().nullable(),
    typeId: zod_1.z.number().nullable(),
    statusNumber: zod_1.z.number().nullable(),
    creatorId: zod_1.z.number().nullable(),
    isLock: zod_1.z.boolean(),
    /* Hai cột của lưới "Văn bản cá nhân" bên hệ cũ, chỉ có ở tab văn bản đã nhận. */
    senderName: zod_1.z.string().nullable().optional(),
    processContent: zod_1.z.string().nullable().optional(),
    /** Trạng thái phiếu nhận, để tô dòng như hệ cũ: chưa đọc / đã đọc / bị thu hồi. */
    isRead: zod_1.z.boolean().optional(),
    isRecalled: zod_1.z.boolean().optional(),
    /** Cột "File văn bản" của lưới hệ cũ — bấm thẳng trên dòng để xem/tải. */
    mainFile: zod_1.z
        .object({
        fileId: zod_1.z.number(),
        fileName: zod_1.z.string().nullable(),
        source: zod_1.z.enum(["files", "attach"]),
    })
        .nullable()
        .optional(),
});
exports.FileMetaSchema = zod_1.z.object({
    fileId: zod_1.z.number(),
    fileName: zod_1.z.string().nullable(),
    mimeType: zod_1.z.string().nullable(),
    sizeBytes: zod_1.z.number().nullable(),
    uploadByStaffId: zod_1.z.number().nullable(),
    uploadAt: zod_1.z.string().nullable(),
    storagePath: zod_1.z.string().nullable(),
    attachType: zod_1.z.number().nullable(),
    source: zod_1.z.enum(["files", "attach"]).optional(),
});
exports.DocumentReceiverSchema = zod_1.z.object({
    staffId: zod_1.z.number(),
    loginName: zod_1.z.string().nullable(),
    fullName: zod_1.z.string().nullable(),
    orgId: zod_1.z.number().nullable(),
    orgName: zod_1.z.string().nullable(),
});
exports.DocumentDetailSchema = exports.DocumentSummarySchema.extend({
    content: zod_1.z.string().nullable(),
    leaderComment: zod_1.z.string().nullable(),
    attachments: zod_1.z.array(exports.FileMetaSchema),
    receivers: zod_1.z.array(exports.DocumentReceiverSchema),
});
exports.DocumentListQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(200).default(50),
    q: zod_1.z.string().trim().optional(),
    folderId: zod_1.z.coerce.number().int().optional(),
    typeId: zod_1.z.coerce.number().int().optional(),
    statusNumber: zod_1.z.coerce.number().int().optional(),
    priorityId: zod_1.z.coerce.number().int().optional(),
    creatorId: zod_1.z.coerce.number().int().optional(),
    fromDate: zod_1.z.string().optional(),
    toDate: zod_1.z.string().optional(),
});
exports.DocumentListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.DocumentSummarySchema),
    total: zod_1.z.number(),
    page: zod_1.z.number(),
    pageSize: zod_1.z.number(),
});
exports.DocumentCreateSchema = zod_1.z.object({
    title: zod_1.z.string().min(1).max(2000),
    code: zod_1.z.string().max(500).optional(),
    registerNumber: zod_1.z.string().max(500).optional(),
    content: zod_1.z.string().optional(),
    signer: zod_1.z.string().max(500).optional(),
    promulgateDate: zod_1.z.string().optional(),
    receiveDate: zod_1.z.string().optional(),
    deadlineDate: zod_1.z.string().optional(),
    priorityId: zod_1.z.number().int().optional(),
    typeId: zod_1.z.number().int().optional(),
});
exports.DocumentUpdateSchema = exports.DocumentCreateSchema.partial();
exports.PublishRequestSchema = zod_1.z.object({
    receivers: zod_1.z
        .array(zod_1.z.object({
        staffId: zod_1.z.number().int(),
        orgId: zod_1.z.number().int().nullable().optional(),
    }))
        .min(1),
});
